import { useAuthStore } from '@/stores/auth';

let pending: { promise: Promise<void>; resolve: () => void } | null = null;

export function requireReauth(): void {
  const s = useAuthStore.getState();
  if (!s.user) {
    // 未登录（bootstrap）→ 正常走登录路由
    s.clear();
    return;
  }
  s.setReauthRequired(true);
  if (!pending) {
    let resolve!: () => void;
    const promise = new Promise<void>((r) => {
      resolve = r;
    });
    pending = { promise, resolve };
  }
}

export function reauthGate(): Promise<void> {
  return pending ? pending.promise : Promise.resolve();
}

export function resolveReauth(): void {
  useAuthStore.getState().setReauthRequired(false);
  pending?.resolve();
  pending = null;
}
